<div #mapContainer class="map-container" [style.height]="height">
  <div class="map-loading" *ngIf="!mapLoaded">
    <i class="pi pi-spinner pi-spin"></i>
    <p>Loading map...</p>
  </div>
</div>